import { defineStore } from 'pinia';

export const useConsultantsStore = defineStore('consultants', {
    state: () => ({ 
        log: {
            activity_log_type_id: null,
            time_spent: null, 
            date: null,
            notes: "",
            areaIds: [],
            parents_trained: null, 
            staff_trained: null, 
            areas_other_details: null,
            hours: null,
            minutes: null,
            type: null,
        },
        logs: [],
        userId: null,
        programId: null,
        users: [],
        email: null,
        phone: null,
        additional: null,
        successMessage: [],
    }),
    getters: {
        currentLog: (state) => state.log,
    },
    actions: {
        resetLog() {
            this.log = {
                activity_log_type_id: null,
                time_spent: null, 
                date: null,
                notes: "",
                areaIds: [],
                parents_trained: null, 
                staff_trained: null, 
                areas_other_details: null,
                hours: null,
                minutes: null,
                type: null,
            }
        }
    },
})